import { createFileRoute } from '@tanstack/react-router';
import { GroupStructurePage } from '@/features/tenants/GroupStructure';
import { MobileGroupStructure } from '@/features/tenants/mobile/MobileGroupStructure';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';

export const Route = createFileRoute('/_app/admin/tenants/group')({
  component: GroupStructure,
});

/**
 * `/admin/tenants/group` — la struttura del gruppo societario.
 *
 * Rotta statica accanto a `$tenantId`: TanStack risolve prima le statiche, quindi «group» non
 * viene letto come l'id di un'azienda.
 */
function GroupStructure() {
  return useIsMobileShell() ? <MobileGroupStructure /> : <GroupStructurePage />;
}
